module.exports = __webpack_public_path__ + "img/card-image-5.677b3fc1.jpg";